(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otul-stopy-video-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('su-insoles-video-strip')) {
    customElements.define('su-insoles-video-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.track = this.querySelector('[data-video-track]');
        this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
        this.videos = Array.from(this.querySelectorAll('video'));
        this.labels = JSON.parse(this.querySelector('[data-video-labels]').textContent);
        this.previous = this.querySelector('[data-video-previous]');
        this.next = this.querySelector('[data-video-next]');
        this.progress = this.querySelector('[data-video-progress]');
        this.toggle = this.querySelector('[data-video-toggle]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.hovered = this.matches(':hover');
        this.focused = this.contains(document.activeElement);
        this.inViewport = false;
        this.timer = null;
        this.scrollFrame = null;
        this.focusFrame = null;
        this.lastProgress = '';
        this.videos.forEach(video => {
          const card = video.closest('[data-video-card]');
          const button = card.querySelector('[data-video-play]');
          const buttonText = button.querySelector('[data-video-play-text]');
          const status = card.querySelector('[data-video-status]');
          const fallback = card.querySelector('[data-video-fallback]');
          let request = 0;
          video.setAttribute('aria-label', card.dataset.videoLabel);
          const showIdle = () => {
            button.hidden = false;
            button.disabled = false;
            buttonText.textContent = this.labels.videoPlay;
          };
          const showError = () => {
            if (signal.aborted) return;
            request += 1;
            showIdle();
            status.textContent = this.labels.error;
            status.hidden = false;
            if (fallback) fallback.hidden = false;
            this.schedule();
          };
          const showPlaying = () => {
            if (signal.aborted || video.paused) return;
            button.hidden = true;
            button.disabled = false;
            buttonText.textContent = this.labels.videoPlay;
            status.hidden = true;
            if (fallback) fallback.hidden = true;
            this.schedule();
          };
          button.addEventListener('click', () => {
            this.pauseAfterInteraction();
            this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
            if (video.error) video.load();
            const currentRequest = ++request;
            button.disabled = true;
            buttonText.textContent = this.labels.loading;
            status.hidden = true;
            video.muted = false;
            try {
              // Start directly inside the user's click so browser activation is retained.
              const playback = video.play();
              if (playback) playback.then(() => {
                if (!signal.aborted && request === currentRequest) showPlaying();
              }).catch(error => {
                if (signal.aborted || request !== currentRequest) return;
                if (error.name === 'AbortError') { showIdle(); return; }
                showError();
              });
            } catch (_) { showError(); }
          }, { signal });
          video.addEventListener('play', () => {
            this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
            this.schedule();
          }, { signal });
          video.addEventListener('playing', showPlaying, { signal });
          video.addEventListener('error', showError, { signal });
          ['pause', 'ended'].forEach(eventName => video.addEventListener(eventName, () => {
            request += 1;
            showIdle();
            this.schedule();
          }, { signal }));
        });
        this.previous.addEventListener('click', () => { this.pauseAfterInteraction(); this.move(-1); }, { signal });
        this.next.addEventListener('click', () => { this.pauseAfterInteraction(); this.move(1); }, { signal });
        this.toggle.addEventListener('click', () => {
          if (this.reducedMotion.matches) return;
          this.paused = !this.paused;
          this.updateControls();
          this.schedule();
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', () => {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = requestAnimationFrame(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
        }, { signal });
        ['pointerdown', 'touchstart', 'wheel'].forEach(eventName => this.track.addEventListener(eventName, () => this.pauseAfterInteraction(), { signal, passive: true }));
        this.track.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) this.pauseAfterInteraction();
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateControls());
        }, { signal, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => { this.updateControls(); this.schedule(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => { this.updateControls(); this.schedule(); });
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          this.schedule();
        }, { threshold: [0, 0.25] });
        this.intersectionObserver.observe(this);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.cleanup();
        }, { signal });
        this.updateControls();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      cleanup() {
        this.abortController?.abort();
        this.abortController = null;
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.focusFrame);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.videos?.forEach(video => video.pause());
        this.timer = null;
      }

      stride() {
        const card = this.cards[0];
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : 1;
      }

      canSlide() {
        return this.track.scrollWidth > this.track.clientWidth + 2;
      }

      isPlaying() {
        return this.videos.some(video => !video.paused && !video.ended);
      }

      pauseAfterInteraction() {
        this.paused = true;
        this.progress.setAttribute('aria-live', 'polite');
        this.updateControls();
        this.schedule();
      }

      updateControls() {
        if (!this.abortController) return;
        const canSlide = this.canSlide();
        this.previous.disabled = !canSlide;
        this.next.disabled = !canSlide;
        this.toggle.disabled = this.reducedMotion.matches || !canSlide;
        this.toggle.textContent = this.reducedMotion.matches ? this.labels.reduced : (this.paused ? this.labels.play : this.labels.pause);
        this.toggle.setAttribute('aria-pressed', String(this.paused || this.reducedMotion.matches));
        const current = Math.min(this.cards.length, Math.max(1, Math.round(this.track.scrollLeft / this.stride()) + 1));
        const message = this.labels.count.replace('__CURRENT__', current).replace('__TOTAL__', this.cards.length);
        if (message !== this.lastProgress) { this.progress.textContent = message; this.lastProgress = message; }
      }

      move(direction, automated = false) {
        if (!this.canSlide()) return;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = this.track.scrollLeft;
        let left;
        if (direction > 0 && current >= maximum - 3) left = 0;
        else if (direction < 0 && current <= 3) left = maximum;
        else left = Math.max(0, Math.min(maximum, (Math.round(current / this.stride()) + direction) * this.stride()));
        this.progress.setAttribute('aria-live', automated ? 'off' : 'polite');
        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.abortController || this.paused || this.hovered || this.focused || !this.inViewport || document.hidden || this.reducedMotion.matches || !this.canSlide() || this.isPlaying()) return;
        this.timer = setTimeout(() => { this.move(1, true); this.schedule(); }, 7000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
